import { Heading, VStack } from '@chakra-ui/react';
import type React from 'react';
import { useHomePageColors } from '@/hooks/useHomePageColors';
import EU_BG from '../../assets/europe.svg';
import DemoTeamList from './DemoTeamList';
import { HOME_DEMO_10_TEAMS } from './homeDemoExample';

const PlaceTeamsSection: React.FC = () => {
  const { heading } = useHomePageColors();

  return (
    <VStack w='full' maxW='full' m='auto' width='full' justifyContent='center' bgImage={EU_BG} bgSize='contain' bgPos='top'>
      <Heading
        fontStyle='italic'
        textAlign='center'
        color={heading}
        mb='2rem'
        width={{
          base: '100%',
          sm: '80%',
          md: '70%',
          lg: '65%',
        }}
        textTransform={{
          base: 'capitalize',
        }}
        fontSize={{
          base: '16px',
          md: '19px',
          lg: '26px',
          xl: '28px',
        }}
        px={{
          base: '1em',
          sm: '2em',
          md: '24px',
        }}
      >
        The Higher You Place Your Teams, The More Points You Get
      </Heading>
      <DemoTeamList withMultipliers teams={[...HOME_DEMO_10_TEAMS]} />
    </VStack>
  );
};

export default PlaceTeamsSection;
